import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { setConsent, useCookieConsent } from "@/hooks/useCookieConsent";

export const CookieBanner = () => {
  const consent = useCookieConsent();
  return (
    <AnimatePresence>
      {!consent && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-2xl rounded-2xl border border-line bg-white/95 p-5 shadow-[0_30px_80px_-24px_rgba(28,27,26,0.45)] backdrop-blur-xl sm:bottom-6"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <Cookie size={22} className="shrink-0 text-clay" />
            <p className="flex-1 text-sm leading-relaxed text-fog">
              Usamos cookies apenas para lembrar a sua escolha e mostrar o mapa do Google. Se recusar, não guardamos nenhum cookie.{" "}
              <Link to="/privacidade" className="underline underline-offset-2 hover:text-clay" data-testid="cookie-privacy-link">Política de privacidade</Link>
            </p>
            <div className="flex gap-2">
              <button data-testid="cookie-decline-btn" onClick={() => setConsent("declined")}
                className="rounded-full border border-line px-5 py-2.5 text-sm text-ink transition-colors duration-300 hover:bg-sand">
                Recusar
              </button>
              <button data-testid="cookie-accept-btn" onClick={() => setConsent("accepted")}
                className="rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-cream transition-colors duration-300 hover:bg-clay">
                Aceitar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
